var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrapper"},[_vm._t("default"),_vm._t("panel"),_c('v-container',{staticClass:"pa-0 table-layout-container",attrs:{"fluid":""}},[_vm._t("table")],2),_vm._t("table_pagination")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }